import { render, staticRenderFns } from "./RecordModals.vue?vue&type=template&id=24619cb3&scoped=true&lang=pug&"
import script from "./RecordModals.vue?vue&type=script&lang=ts&"
export * from "./RecordModals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24619cb3",
  null
  
)

export default component.exports